import React, { useState, useRef } from "react";
import { Popover, Typography, Box, Button } from "@mui/material";

const ConfirmPopover = ({
  children,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const triggerRef = useRef(null);
  const handleOpen = (e) => {
    setAnchorEl(triggerRef.current);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleConfirm = () => {
    onConfirm?.();
    handleClose();
  };
  return (
    <>
      <span ref={triggerRef} onClick={handleOpen}>
        {children}
      </span>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: 2,
            width: 240,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            boxShadow: 4,
          },
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          {title}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          align="center"
          sx={{ mb: 2 }}
        >
          {message}
        </Typography>

        <Box display="flex" gap={1}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleClose}
            sx={{ fontSize: "0.75rem", px: 2, py: 0.5 }}
          >
            {cancelText}
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={handleConfirm}
            sx={{
              fontSize: "0.75rem",
              color: "#fff",
              px: 2.5,
              py: 0.5,
            }}
          >
            {confirmText}
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default ConfirmPopover;
